// @ts-nocheck
import React from 'react';
import classNames from 'classnames';

import IconSpinner from '../IconSpinner/IconSpinner';

import css from './Web3TransactionFeedback.module.css';

export type Web3FeedbackPhase = 'processing' | 'success';

export interface Web3TransactionFeedbackProps {
  phase: Web3FeedbackPhase;
  title?: string;
  subtitle?: string;
}

const Web3TransactionFeedback: React.FC<Web3TransactionFeedbackProps> = ({
  phase,
  title,
  subtitle,
}) => {
  const isSuccess = phase === 'success';

  return (
    <div
      className={css.overlay}
      role="status"
      aria-live="polite"
      data-testid="web3-transaction-feedback"
    >
      <div className={classNames(css.panel, { [css.processing]: !isSuccess })}>
        {isSuccess ? (
          <span className={css.successIcon} aria-hidden="true">
            ✓
          </span>
        ) : (
          <div className={css.spinnerWrap}>
            <IconSpinner rootClassName={css.spinner} />
          </div>
        )}

        <h3 className={css.title}>
          {title ||
            (isSuccess ? 'Transaction confirmed' : 'Waiting for wallet approval')}
        </h3>
        <p className={css.subtitle}>
          {subtitle ||
            (isSuccess
              ? 'Your on-chain action completed successfully.'
              : 'Approve the request in MetaMask or Rabby to continue.')}
        </p>

        {!isSuccess ? (
          <div className={css.steps}>
            <div className={classNames(css.step, css.stepWallet, css.stepActive)}>
              1. Waiting for wallet approval
            </div>
            <div className={classNames(css.step, css.stepMining)}>2. Transaction pending (mining)</div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default Web3TransactionFeedback;
